import { useMemo } from "react";
import useResponsiveValues from "@/components/editor/hooks/useResponsiveValues";
import { Props } from "./ButtonSettings";
import useVariableValues from "../../hooks/useVariableValues";

const PROPS: (keyof Props)[] = ["size", "variant", "fullWidth", "color", "text"];

const useNormalizeButtonSettings = (props: Props) => {
  const responsive = useResponsiveValues();
  const vv = useVariableValues();

  const draft = useMemo(() => {
    const draft: Props = {};

    PROPS.forEach((prop) => {
      if (props[prop]) {
        const value = responsive.getValue(props[prop]);

        if (prop === "text") {
          draft[prop] = vv.getValue(value ?? "");
        } else {
          draft[prop] = value;
        }
      }
    });

    return draft;
  }, [props, responsive]);
  return draft;
};

export default useNormalizeButtonSettings;
